import React, { Component } from "react";
import {
  Modal,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { connect } from "react-redux";
import ConfettiExplosion from "react-confetti-explosion";
import SenseiLogo from "../../assets/images/senseiupdatelogo.svg";
import * as actionCreators from '../../action/quote_order/order.action'

class ThankYou extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExploding: false,
      windowHeight: window.innerHeight
    };
  }
  handleClick = () => {
    this.props.handleClose();
    this.setState({ isExploding: false });
    this.props.updateTempPostData("", true);
    if(window.location.href.includes('3d-public')) {
      window.location.reload()
    }
  };

  ForConfetti = () => {
    setTimeout(() => {
      this.setState({ isExploding: true });
      setTimeout(() => {
        document.querySelector(".thank-check").classList.add("endconfeti");
      }, 50);
      const getsavemodal = document.querySelector(".save-later-thanku-modal");
      if (getsavemodal !== null) {
        getsavemodal.parentNode.style.zIndex = 99999;
      }
    }, 200);
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    if (this.props.show == true) {
      this.ForConfetti();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps) {
    if (this.props.show === true && this.props.show !== prevProps.show) {
      this.ForConfetti();
    }
  }

  handleResize = () => {
    this.setState({ windowHeight: window.innerHeight });
  };

  render() {
    let logoIMG = window.location.origin + "/logo.svg";

    let textBeforePhoneNumner = '';
    let textAfterPhoneNumber = '';

    if (this.props.domain_url != "" && this.props.domain_url == "samsonsteelstructures.com") {
      textBeforePhoneNumner = "Once a specialist reviews your order, one of our sales team will email a quote and contact you, ";
      textAfterPhoneNumber = " ";
      
    }  else if(this.props.domain_url != "" && this.props.domain_url == "nationalcarportsonline.com") {
      textBeforePhoneNumner = "We will email you a quote with your building specifications and pictures. Feel free to call us at ";
      textAfterPhoneNumber = " with any questions or to place an order";
    } else if(this.props.domain_url != "" && this.props.domain_url == "metalcarportdepotllc.com"){
      textBeforePhoneNumner = "We will verify that your quote is accurate and based on the best available price in your area. We will contact you with a formal quote as soon as possible. In the meantime, we can be reached at ";
      textAfterPhoneNumber = ", Mon - Fri 8:30 am to 7:00 pm, and on Sat 9:00 am to 3:00 pm for answers to your questions or assistance with your order.";
    } else {
      textBeforePhoneNumner = "We have emailed the quote to you with your building specifications and pictures. Feel free to call us at ";
      textAfterPhoneNumber = " with any questions or to place an order.";
    }

    return (
      <div>
        <Modal
          show={this.props.show}
          backdrop="static"
          onHide={this.handleClick}
          centered
          dialogClassName={
            this.props.thankYouForSaveLater
              ? "save-later-thanku-modal react-modal modal-big thank-for-save-later"
              : "save-later-thanku-modal react-modal modal-big "
          }
          backdropClassName="ract-modal-pre-parent"
        >
          <button className="close" onClick={this.handleClick}>
            <span className="icon-close"></span>
          </button>
          <Modal.Body>
            <div className="thank-logo">
              {/*<img src ={process.env.REACT_APP_BASE_URL+SenseiLogo} alt="Sensei 3D" />                    */}
              <img src={logoIMG} alt="Sensei 3D" />
            </div>
            <div className="thank-container" style={{height: this.state.windowHeight}}>
              <div className="thank-content">
                <div className="thank-check">
                  {this.state.isExploding && (
                    <ConfettiExplosion
                      colors={["#fecbc4", "#5fc8a6", "#fac82b", "#cfaa04"]}
                      className="confetinew"
                      zIndex="999999999999999"
                      duration="4000"
                      particleCount="500"
                      width="1600"
                    />
                  )}
                  <div className="thankyou-check">
                    <span class="icon-checkmark-ico"></span>
                  </div>
                </div>

                {this.props.domain_url != "" &&
                this.props.domain_url == "samsonsteelstructures.com" ? (
                  <h1>
                    Thank You and God Bless,
                    <br /> Your Request Has Been Submitted.
                  </h1>
                ) : (
                  <h1 className="thankyou-title">
                    {window.innerWidth > 992 
                    ? 
                      this.props.domain_url != "" &&
                      this.props.domain_url == "idealsteelbuildingsofca.com" ?
                        <span>Thank you!</span>
                        :
                        (this.props.domain_url == 'metalcarportdepotllc.com' ? <span>Thank you for submitting your request.</span> : <span>Thank You, for your interest in us.</span>)
                    :
                      this.props.domain_url != "" &&
                      this.props.domain_url == "idealsteelbuildingsofca.com" ?
                        <span>Thank you!</span>
                      :
                        (this.props.domain_url == 'metalcarportdepotllc.com' ? <span>Thank You<br></br> submitting your request.</span> : <span>Thank You,<br></br> for your interest in us.</span>)
                    }
                  </h1>
                )}

                { 
                  (this.props.domain_url != '' && this.props.domain_url == "keensbuildings.com")?
                  <a className='finance-rto-container rto-thankyou' href="https://keensbuildings.com/keens-buildings-application-general/" target="_blank"><span className="icon-dollar finance-rto-dollar"></span> <span className='finance-rto'>View Financing Offers<hr className='under-line'/></span></a>
                  :
                  ""
                }

                <div className="for-savelaterthanks">
                  <div className="thank-box">

                    {(this.props.domain_url != "" &&
                      this.props.domain_url == "idealsteelbuildingsofca.com" ? (
                          <p className="thankyou-des">
                          A representative from our team will review your design and send you a quote with a full price breakdown within 2–3 business days.
                          <br/>
                          We’re excited to be part of your project and look forward to helping bring your vision to life.       
                          <p>
                            If you’d like to expedite your quote or have any questions, please call us at{" "}
                            <a
                              className="anchor-primary cursor-default"
                              href={"tel:" + this.props.phone_number}
                            >
                              {this.props.phone_number}.
                            </a>{" "}
                          </p>
                      </p>
                      ) : (
                        <p className="thankyou-des">
                          {textBeforePhoneNumner}
                        <a
                          className="anchor-primary cursor-default"
                          href={"tel:" + this.props.phone_number}
                        >
                          {this.props.phone_number}
                        </a>
                        {textAfterPhoneNumber}
                      </p>
                      )
                    )}
                  </div>
                </div>

                <div className="for-checkoutthanks">
                  <div className="thank-box ">
                    {this.props.paymentFailedMessage == true ? (
                      <p className="mb-0 thankyou-des">
                        We have received your Building Order, but could not
                        process your payment due to some technical error. Please
                        see the attached Order Summary and Unpaid Invoice for
                        your building order. We have also sent these PDFs to
                        your email.{" "}
                      </p>
                    ) : null}

                    {
                      this.props.domain_url != "" &&
                    this.props.domain_url == "idealsteelbuildingsofca.com" ? 
                        <p className="thankyou-des">
                           A representative from our team will review your design and send you a quote with a full price breakdown within 2–3 business days.
                          <br/>
                          We’re excited to be part of your project and look forward to helping bring your vision to life.
                          
                          <p>
                            If you’d like to expedite your quote or have any questions, please call us at{" "}
                          <a
                            className="anchor-primary cursor-default"
                            href={"tel:" + this.props.phone_number}
                          >
                            {this.props.phone_number}.
                          </a>{" "}
                          </p>
                      </p>
                    :
                      <p className="mb-0 thankyou-des">
                        Our sales representative will call you in 24-hours for
                        final confirmation and schedule your building
                        installation. Feel free to call us at{" "}
                        <a
                          className="anchor-primary cursor-default"
                          href={"tel:" + this.props.phone_number}
                        >
                          {this.props.phone_number}
                        </a>{" "}
                        for any questions.
                      </p>
                    }
                 
                  </div>
                </div>

                <div
                  className={
                    this.props.domain_url != "" &&
                    (this.props.domain_url == "samsonsteelstructures.com" || this.props.domain_url == "nationalcarportsonline.com" )
                      ? " d-none"
                      : "for-savelaterthanks"
                  }
                >
                  <a
                    href={this.props.Qpdf_url}
                    target="_blank"
                    className="btn btn-primary dwn-quote"
                  >
                    <span className="icon-download icon mr-1"></span>{" "}
                    Download Quote
                  </a>
                </div>

                <div className="for-checkoutthanks">
                  <div className="download-or-inv">
                    <a
                      href={this.props.orderPDFURL}
                      target="_blank"
                      className="btn btn-primary dwn-quote resize-btn"
                    >
                      <span className="icon-download icon mr-1"></span>
                      Order   
                    </a>

                    <a
                      href={this.props.invoicePDFURL}
                      target="_blank"
                      className={this.props.informUserFlag && this.props.informUser != "" ? 'd-none' : "btn btn-primary dwn-quote resize-btn ml-3"}
                    >
                      <span className="icon-download icon mr-1"></span>
                      Invoice
                    </a>
                  </div>
                </div>
                <div className={this.props.informUserFlag && this.props.informUser != "" ? "alert-payment" : "alert-payment d-none"}>
                  <div>
                    <span className="icon-report pr-2"></span>
                    {this.props.informUser}
                  </div>
                  <div>
                    <a href={this.props.invoicePDFURL} target="_blank"><span className="icon-download mr-1"></span></a><a className="custom-link"  href={this.props.invoicePDFURL} target="_blank">Unpaid Invoice</a>
                  </div>
                </div>
              </div>
              
              <div className="thank-strip">
                <div className="thank-strip-content">
                  <strong>Be Rest Assured of</strong>
                  <ul className="list-support">
                    <li className="item-support">
                      <div className="icon">
                        <i className="icon-timely-delivery"></i>
                      </div>
                      <span className="text">
                        Timely Delivery of Your Building
                      </span>
                    </li>
                    <li className="item-support">
                      <div className="icon">
                        <i className="icon-quality"></i>
                      </div>
                      <span className="text">
                        Free Installation of Building{" "}
                        <span style={{ fontSize: "12px", color: '#666666' }}>(Most Areas)</span>
                      </span>
                    </li>
                    <li className="item-support">
                      <div className="icon">
                        <i className="icon-support"></i>
                      </div>
                      <span className="text">Customer Support on Call</span>
                    </li>
                  </ul>
                </div>
              </div>

              {/*                  
                  <div>
                        <h5 className="text-uppercase  rajdhani-bold  mb-3 ">Be rest assured of</h5>

                  <div className="thank-you-after-process">
                      <ul className="list-style-none pl-0">
                        <li style={style}>
                          <div className="icon-thank timely-deliver">

                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 130 73"><path className="st0" d="M99 32v11h17l-8.6-11H99zm2 9v-7h5.5l5.4 7H101z"/><circle className="st0" cx="44" cy="65" r="3"/><circle className="st0" cx="19" cy="65" r="3"/><circle className="st0" cx="111" cy="65" r="3"/><path className="st0" d="M88 7h-2v8.4l5.2 6.2 1.6-1.2-4.8-5.8z"/><path className="st0" d="M130 44.6L113.4 26H98.2l-.1.1c3-2.7 4.9-6.7 4.9-11.1 0-8.3-6.7-15-15-15S73 6.7 73 15s6.7 15 15 15c.7 0 1.4-.1 2-.2V64H51.9c-.5-3.9-3.9-7-7.9-7s-7.4 3.1-7.9 7H27c-.5-3.9-3.9-7-7.9-7s-7.4 3.1-7.9 7H2V16h71.1c0-.3-.1-.7-.1-1s0-.7.1-1H0v52h11.1c.5 3.9 3.9 7 7.9 7s7.4-3.1 7.9-7H36c.5 3.9 3.9 7 7.9 7s7.4-3.1 7.9-7H103.1c.5 3.9 3.9 7 7.9 7s7.4-3.1 7.9-7H130V44.6zM19 71c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm25 0c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm31-56c0-7.2 5.8-13 13-13s13 5.8 13 13-5.8 13-13 13-13-5.8-13-13zm36 56c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm17-7h-9.1c-.5-3.9-3.9-7-7.9-7s-7.4 3.1-7.9 7H92V29.4h-.1c1.3-.4 2.6-.9 3.7-1.6l-.1.1h17.1L128 45.4V64zM97 27c-.1.1-.2.1-.2.2 0-.1.1-.2.2-.2z"/></svg>                 
                          </div>
                          <div className="thanku-info">Timely Delivery of<br/> Your Building</div>
                        </li>
                        <li  style={style}>
                          <div className="icon-thank building-installation-icon">
                                   
                              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 104 72" ><path className="st0" d="M92 68V46h9V22H79L34 0v11h-2v2h2v1h2v-1h2v-2h-2V7.3l41 26.4V46h9v22H74v4h30v-4H92zM77 31.3L36 4.9V3.2l41 20v8.1zM79 44V24h20v20H79zm11 24h-2V46h2v22z"/><path className="st0" d="M40.2 21.1c1.2-2.5.1-5.5-2.4-6.6-1-.5-2.1-.6-3.2-.4l.4 2c.6-.1 1.3-.1 1.9.2 1.5.7 2.1 2.5 1.5 4-.7 1.5-2.5 2.1-4 1.5-.6-.3-1.2-.8-1.5-1.5l-1.8.8c.3.7.8 1.2 1.3 1.7L1 41.4v7.4l3-2V70H0v2h68v-2h-4V46.6l4 2v-7.2L37.2 23.7c1.3-.4 2.4-1.3 3-2.6zM21 46v2h-1v-3h30v3h-1v-2H21zm41 24H49V50h3v-7H18v7h3v20H6V45.6l28-16.4 10.2 6L62 45.6V70zm4-27.5v2.9l-2.5-1.2L34 26.8 4 44.4l-1 .7v-2.6l31-18.4 32 18.4z"/></svg>
                          </div>
                          <div className="thanku-info">Free Installation<br/> of Building (Most Areas)</div>
                        </li>
                        <li style={style}>
                          <div className="icon-thank expert-icon">
                              <svg id="expert" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.1 70.1"><path d="M61,54.4,44,48.3v-6h0a5.51,5.51,0,0,0,2-1.7h5.7l1.6-2.7V31.2a6,6,0,0,0,1.6-3.7,6.39,6.39,0,0,0-2.2-5.4V20.7c0-10.4-8-18.8-17.9-18.8s-18.1,8.5-18.1,19v2h.1a6.81,6.81,0,0,0-1.4,4.6,6.41,6.41,0,0,0,6.4,5.8h.5l.3,3.3a6.93,6.93,0,0,0,3.6,5.6l1.7,1.1v4.9l-17,6.1a3.85,3.85,0,0,0-3,3.8V72h2V58.2a1.93,1.93,0,0,1,1.5-1.9l16.2-5.8,3.3,3.7-1.3.9,1.7,5.3L29.8,70.8l2,.3,1.4-9.8h3.1l1.5,9.8,2-.3L38.4,61l2-5.8-1.1-.8,3.9-4.3,17.2,6.1h.1A1.93,1.93,0,0,1,62,58.1V72h2V58.2A3.85,3.85,0,0,0,61,54.4ZM50.6,38.6H47.2c0-.1.1-.2.1-.4V38a1.93,1.93,0,0,1,.3-1l.1-.2.3-3.6h.6a6,6,0,0,0,2.7-.6v4.6Zm-1.4-7.3.8-8.5a4.58,4.58,0,0,1,3,4.6A4.36,4.36,0,0,1,49.2,31.3ZM34.8,4c8.8,0,15.9,7.5,15.9,16.8V21a8.33,8.33,0,0,0-1.5-.4l-.5-.1A13.57,13.57,0,0,0,35.1,7.9H35A13.86,13.86,0,0,0,21.5,20.6h-.3a6.19,6.19,0,0,0-2.4.8V21C18.8,11.6,26,4,34.8,4ZM17.5,27.4a4.46,4.46,0,0,1,3-4.6l.8,8.5A4.27,4.27,0,0,1,17.5,27.4Zm7.1,9.1-1.2-15A11.88,11.88,0,0,1,35,9.9h.1A11.67,11.67,0,0,1,46.8,21.4l-1,15a6.47,6.47,0,0,0-.4,1.3,3.55,3.55,0,0,1-.4.9H36.7v2h6.1l-6,3.8H33.3l-6.1-3.9A4.74,4.74,0,0,1,24.6,36.5ZM38,55.9l-1.2,3.5H33.2L32.1,56l3-2.1Zm-3-4.5-2.4,1.7-2.9-3.3.3-.1v-5l2.8,1.8h4.7L42,43.6v4.9l-4.3,4.8Z" transform="translate(-7.9 -1.9)" className="st0" /></svg>                            
                          </div>
                          <div className="thanku-info">Customer Support<br/> on Call</div>
                        </li>
                        
                      </ul>
                  </div>              
                
                
                  </div>*/}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default connect(undefined, actionCreators)(ThankYou);
